export const MIN_NUMBER_VALUE = 0;
